import { withChartLayout } from 'components/common';
import SavedOstomies from 'components/features/chart/ostomies/saved-ostomies/SavedOstomies';

const SavedOstomiesPage = withChartLayout('Saved Ostomies Charting')(SavedOstomies);
export default SavedOstomiesPage;
